import React from 'react'

import { IconButton } from '@sidecar-components/molecules/IconButton'
import { Toggletip } from '@sidecar-components/atoms/Toggletip'
import { IconSize } from '@sidecar-components/atoms/Icon'
import { TooltipButtonProps } from './TooltipButton.types'

/**
 * @param {string} className - Any additional classes to add to the icon button.
 * @param {string} id - Unique identifier
 * @param {IconSize} size - Size of the tooltip button
 * @param {string} testId - Adds a data-testid param to the button for Heap
 *   tracking and automated testing.
 * @param {React.ReactNode | string} tooltip - What should be shown in the
 *   tooltip.
 * @returns {React.ReactNode} - A "?"" IconButton that toggles a tooltip on
 *   click.
 */
export const TooltipButton = ({
  className = '',
  id = '',
  isOpen,
  onOpenChange,
  size = IconSize.SM,
  testId = '',
  tooltip,
}: TooltipButtonProps) => {
  return (
    <Toggletip
      open={isOpen}
      onOpenChange={onOpenChange}
      content={tooltip}
      // Make sure we don't wrap a button in a button.
      // Instead, pass the toggletip properties to the iconbutton.
      addButtonWrapper={false}
    >
      <IconButton
        className={className}
        testId={testId}
        icon="tooltip"
        id={id}
        label="Learn more"
        size={size ?? IconSize.SM}
      />
    </Toggletip>
  )
}
